import React from "react";
import { Modal, Button } from "react-bootstrap";
import {RefreshSpinIcon} from "../Icons/RefreshSpinIcon";

interface SmallModalProps {
    show: boolean;
    body: React.ReactNode;
    onClose: () => void;
    onConfirm?: () => void;
    confirmText?: string;
    isConfirmLoading?: boolean;
}

const SmallModal: React.FC<SmallModalProps> = ({ show, body, onClose, onConfirm, confirmText, isConfirmLoading }) => {
    return (
        <Modal show={show} onHide={onClose} size="lg" centered>
            <Modal.Body className={"pt-4"}>{body}</Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose} disabled={isConfirmLoading}>
                    Cerrar
                </Button>
                {onConfirm && (
                    <Button variant="primary" onClick={onConfirm} disabled={isConfirmLoading}>
                        {
                            isConfirmLoading && <RefreshSpinIcon />
                        }
                        {
                            !isConfirmLoading && (confirmText ?? 'Confirmar')
                        }
                    </Button>
                )}
            </Modal.Footer>
        </Modal>
    );
};

export default SmallModal;
